import { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";

export const getSubscriptionPlans = (): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      Accept: "application/json",
    },
  };
  return axiosAuth.get(API_PATH().apis.plans, config);
};

export const createZohoCustomer = (customer: any): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.zohoCustomer, customer);
};

export const createZohoSubscription = (
  subscription: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.zohoSubscription, subscription);
};

export const updateCardStatus = (): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.cardStatus, {});
};

export const getSubscriptionPermissions = (): Promise<AxiosResponse> => {
  const authToken = localStorage.getItem("token");
  if (!authToken) {
    return Promise.reject("Auth token is not available.");
  }

  let config: AxiosRequestConfig = {
    params: {
      //companyId: company,
    },
  };
  return axiosAuth
    .get(API_PATH().apis.subscription, config)
    .then((response: AxiosResponse) => {
      return response;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const getSubscriptionTransactions = (): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {},
  };
  return axiosAuth.get(API_PATH().apis.subscriptionTransactions, config);
};

export const paymentRequest = (): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      //companyId: company,
    },
  };
  return axiosAuth.get(API_PATH().apis.paymentrequest, config);
};

export const getAddons = (): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      Accept: "application/json",
    },
  };
  return axiosAuth.get(API_PATH().apis.addons, config);
};

export const upgradeSubscription = (
  upgradeRequest: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.upgradeSubscription, upgradeRequest);
};

export const increaseAddon = (addonRequest: any): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.increaseAddon, addonRequest);
};
